import { render } from "./InformesView.vue?vue&type=template&id=9c7b5708&scoped=true"
import script from "./InformesView.vue?vue&type=script&lang=js"
export * from "./InformesView.vue?vue&type=script&lang=js"

import "./InformesView.vue?vue&type=style&index=0&id=9c7b5708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7b5708"]])

export default __exports__